// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qi_a","ListOfForumsRight__brandDaysPosts":"qi_b bht_sw"};